<template>
    <div class="h-rowIn back" style="width: 38.5%;">
        <div class="h-rowBox" :style="{height: divheight}">
            <div class="h-rowTitle">
                <div class="h-disTable">
                    <div class="h-tableCell" style="height:100%;display:flex;justify-content:space-between;align-items:center;">
                        <h1>待办事项</h1>
                        <span>
                             <el-select v-model="taskstatus" @change="changeOption" placeholder="全部类型">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </span>
                    </div>
                </div>
            </div>
            <div class="h-rowCon">
                <div class="h-todoListOut" style="padding:0">
                    <div class="h-todoList">
                        <ul>
                            <li v-for="(o,i) in tableData" :key='i'>
                                <div>
                                    <el-tag class="ljj_tags h-label h-yellowLabel h-blueLabel h-fl" :title="o.progressName">{{o.progressName}}</el-tag>
                                    <span :title="o.cjrname" class="h-todoLabel h-fl" style="width:0.75rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{o.cjrname}}</span>
                                    <a class="h-ellipsis h-fl"  :title="o.name">{{o.name}}</a>
                                    <span class="h-todoTime h-fl" >{{o.begindateStr}}</span>
                                    <el-tag class="ljj_tags h-label2 handHover h-fr" :class="o.status==0?'h-blueLabel':'h-greenLabel'"
                                            @click="toShowOrComplate(o)">
                                        {{o.status==0?'去处理':'查看'}}
                                    </el-tag>
									<div style="clear: both;"></div>
                                </div>
                            </li>
                            <li v-if="tableData.length <3">
                                <img src="../../assets/images/mylittle.png" style="width:5rem;height:4.5rem;margin:20px 0 0 30px">
                            </li>
                        </ul>
                        <div class="h-pagination fenyes" style="padding-bottom:0.1rem" v-if="tableData.length=0">
                            <el-pagination
                                    @current-change="handleCurrentChange"
                                    :page-size="pagesize"
                                    layout="sizes, prev, pager, next"
                                    :total="query.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        props:{
            divheight:null,
            pagesize:{
                type: Number,
                default: 10
            }
        },
        data() {
            return {
                query:{
                    status:0,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                tableData: [],
                dianlianglist:[1,1,1,1],
                taskstatus:'0',
                options: [{
                    value: '0',
                    label: '未完成'
                }, {
                    value: '1',
                    label: '已完成'
                }, {
                    value: '',
                    label: '全部'
                }],
            };
        },
        created() {
            this.query.pageSize = this.pagesize;
            this.search();
        },
        methods: {
            changeOption(i){
                this.query.status = i;
                this.search();
            },
            handleCurrentChange(i){
                this.query.pageNo = i;
                this.search();
            },
            search(){
                this.query.pageSize = this.pagesize;
                ss.taskservice.query(this.query).then(rd=>{
                    this.query.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            toShowOrComplate(r){
                this.$router.push({path: r.dburl,query: {taskid:r.id,ywid:r.ywid,instid:r.instid,taskstatus:r.status,f:1}})
            },
        },
    }
</script>

<style>
    .handHover:hover{
        cursor:pointer
    }
    .h-tableCell .el-input__inner{
        border: 1px solid #999!important;
        color: #999!important;
    }
    .back .h-label.h-blueLabel{
        width: 1rem;
        padding: 0 0.15rem;
		text-align: center;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .h-todoList > ul > li a{
        width: 24%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
</style>
